export default "__VITE_ASSET__Dx2eNZo7__"